import { pxToRem } from 'utils/convert';

export type BorderRadius = 'none' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'full';

export const borderRadius: Record<BorderRadius, string> = {
  none: pxToRem(0),
  sm: pxToRem(2),
  md: pxToRem(4),
  lg: pxToRem(6),
  xl: pxToRem(8),
  xxl: pxToRem(12),
  full: pxToRem(1000),
} as const;
